if (!customElements.get('oven-faq')) {
  class OvenFaq extends HTMLElement {
    connectedCallback() {
      if (this.dataset.faqInit === 'true') return;
      this.dataset.faqInit = 'true';

      this.querySelectorAll('.product-faq-item > .title').forEach((title) => {
        const toggle = () => {
          const item = title.closest('.product-faq-item');
          const text = item && item.querySelector('.text');
          const isOpen = title.classList.contains('open');

          title.classList.toggle('open', !isOpen);
          title.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          if (text) {
            if (isOpen) {
              text.setAttribute('hidden', '');
            } else {
              text.removeAttribute('hidden');
            }
          }
        };

        title.addEventListener('click', toggle);
        title.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggle();
          }
        });
      });
    }
  }

  customElements.define('oven-faq', OvenFaq);
}
